import { Breakpoint, Button, Grid } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { getNavBarOptions } from 'src/components/BottomNavBar/constants';
import { useAppUI } from 'src/context/AppUIProvider/useAppUI';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import { FlexContainer } from '../styles';

interface HeaderNavigationProps {
  columns?: { [key in Breakpoint]?: number };
}

const DEFAULT_COLUMNS = { md: 4.4, xl: 4.4 };

export default function HeaderNavigation({ columns }: HeaderNavigationProps) {
  const { isMobile } = useAppUI();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user, isB2b } = useAuthContext();

  const navBarOptions = getNavBarOptions(!!isB2b);

  const columnBreakpoints = columns ?? DEFAULT_COLUMNS;

  if (isMobile) return null;

  return (
    <Grid item {...columnBreakpoints}>
      <FlexContainer justifyContent="flex-end" gap={2} width="100%">
        <FlexContainer maxWidth={500}>
          {navBarOptions.map((page) =>
            page.disabled ? null : (
              <Button
                key={page.href}
                onClick={() => navigate(page.href)}
                sx={{ display: 'block', px: { md: 0.8, xl: 1 }, minWidth: 0 }}
                size="small"
                color={pathname === page.href ? 'secondary' : 'inherit'}
              >
                {page.label.toLowerCase() === 'cuenta'
                  ? user
                    ? page.label
                    : 'Ingresar'
                  : page.label}
              </Button>
            )
          )}
        </FlexContainer>
      </FlexContainer>
    </Grid>
  );
}
